<template>

  <div>
    <data-table
    table-ref="rentalsummarytable"

    title="Rentals/Lease"
    icon="fa fa-hand-holding-usd"

    search-placeholder="Site name, Landlord"

    url="/report/property/rentals/summary"
    :fields="fields" />

</div>
</template>

<script>

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {
  mixins: [DateMixins, NumberMixins],

  data () {
    return {
      stats: this.getStats(),
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'landStatus',
          title: 'Status',
          titleClass: 'hidden-md-and-down text-primary',
          dataClass: 'hidden-md-and-down text-primary'
        },
        {
          name: 'landType',
          title: 'Land Type',
          titleClass: 'hidden-md-and-down text-warning',
          dataClass: 'hidden-md-and-down text-warning'
        },
        {
          name: 'name',
          title: 'Landlord'
        },
        {
          name: 'siteName',
          title: 'Site Name'
        },
        {
          name: 'deposit',
          title: 'Deposit',
          callback: this.formatMoney,
          titleClass: 'hidden-md-and-down text-success',
          dataClass: 'hidden-md-and-down text-success'
        },
        {
          name: 'depositMonths',
          title: 'Dep. Mths',
          callback: this.formatInteger,
          titleClass: 'hidden-md-and-down text-success',
          dataClass: 'hidden-md-and-down text-success'
        },
        {
          name: 'lastRenewalDate',
          title: 'Last Renewal',
          callback: this.formatDate,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'renewals',
          title: 'Renewals',
          callback: this.formatInteger,
          titleClass: 'hidden-md-and-down text-primary',
          dataClass: 'hidden-md-and-down text-primary'
        },
        {
          name: 'nextPaymentDate',
          title: 'Date Due',
          callback: this.formatDate,
          titleClass: 'text-danger',
          dataClass: 'text-danger text-right'
        },
        {
          name: 'nextPayment',
          title: 'Due',
          callback: this.formatMoney,
          titleClass: 'hidden-sm-and-down text-danger',
          dataClass: 'hidden-sm-and-down text-danger text-right'
        }
      ]
    }
  }
}
</script>
